var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styleToCss from '@hellodarwin/core/lib/features/helpers/style-to-css';
import { useMemo } from 'react';
import { css, useTheme } from 'styled-components';
import { InitialStyledQueriesProps, } from './styles';
const prepareTabletStyling = (theme, cap, noPadding) => {
    return css `
    width: calc(100% - 200px);
    ${!noPadding
        ? css `
          padding-top: ${theme.spacing.xl}px;
          padding-bottom: ${theme.spacing.xl}px;
        `
        : ''}
    max-width: calc(${cap} - 300px);
  `;
};
const prepareSmallDesktopStyling = (theme, cap, noPadding) => {
    return css `
    width: ${cap};
    ${!noPadding
        ? css `
          padding-top: ${theme.spacing.xxl}px;
          padding-bottom: ${theme.spacing.xxl}px;
        `
        : ''}
    max-width: calc(100% - ${theme.spacing.xxl}px);
  `;
};
const getCapValue = (cap) => {
    return typeof cap === 'number' ? `${cap}px` : cap;
};
const RowAlignement = {
    center: 'center',
    start: 'flex-start',
    end: 'flex-end',
};
const RowStyling = (theme, direction, alignement) => css `
  display: flex;
  flex-direction: ${direction.includes('reverse') ? 'row-reverse' : 'row'};
  gap: ${theme.spacing.xxl}px;
  align-items: ${RowAlignement[alignement]};
`;
const ColumnAlignement = {
    center: 'center',
    start: 'flex-start',
    end: 'flex-end',
};
const ColumnStyling = (theme, direction, alignement) => css `
  display: flex;
  flex-direction: ${direction.includes('reverse')
    ? 'column-reverse'
    : 'column'};
  gap: ${theme.spacing.xl}px;
  align-items: ${ColumnAlignement[alignement]};
`;
export const directionStyling = (theme, direction, alignement) => {
    return css `
    ${direction.includes('row')
        ? RowStyling(theme, direction, alignement)
        : ColumnStyling(theme, direction, alignement)};

    @media (max-width: ${theme.breakpoints.tablet}px) {
      ${ColumnStyling(theme, direction, alignement)};
      flex-direction: column;
    }
  `;
};
const prepareBasicStyling = (theme, cap, noPadding, direction, alignement) => {
    const capValue = getCapValue(cap);
    return css `
    width: calc(100% - 48px);
    margin: 0 auto;
    max-width: 450px;
    ${!noPadding
        ? css `
          padding-top: ${theme.spacing.xl}px;
          padding-bottom: ${theme.spacing.xl}px;
        `
        : ''}
    ${directionStyling(theme, direction, alignement)}
    @media (min-width: ${theme.breakpoints.tablet}px) {
      ${prepareTabletStyling(theme, capValue, noPadding)}
    }
    @media (min-width: ${theme.breakpoints.md}px) {
      ${prepareSmallDesktopStyling(theme, capValue, noPadding)}
    }
  `;
};
const useContainerProps = (props) => {
    const theme = useTheme();
    return useMemo(() => {
        var _a, _b, _c;
        const { xl, xxl, tablet, wide, ultra, md, mobile, l, children, id, className, removeContainer } = props, defaultViewProps = __rest(props, ["xl", "xxl", "tablet", "wide", "ultra", "md", "mobile", "l", "children", "id", "className", "removeContainer"]);
        const currentProps = Object.assign(Object.assign({}, InitialStyledQueriesProps), { $default: css `
        width: 100%;
      ` });
        const currentContentProps = Object.assign(Object.assign({}, InitialStyledQueriesProps), { $default: !removeContainer
                ? prepareBasicStyling(theme, (_a = defaultViewProps.cap) !== null && _a !== void 0 ? _a : theme.caps.normal, !!defaultViewProps.noPadding, (_b = defaultViewProps.direction) !== null && _b !== void 0 ? _b : 'column', (_c = defaultViewProps.alignement) !== null && _c !== void 0 ? _c : 'center')
                : css `
            width: 100%;
          `, $ultra: undefined, $wide: undefined, $xxl: undefined, $xl: undefined, $lg: undefined, $md: undefined, $tablet: undefined, $mobile: undefined });
        const prepareProps = (data, mediaQuery) => {
            if (!!data && Object.keys(data).length) {
                const { noPadding, fullWidth, overflowHidden, containerBackgroundColor, cap, backgroundColor, styles, } = data;
                if (!!containerBackgroundColor) {
                    currentProps[mediaQuery] = css `
            ${currentProps[mediaQuery]};
            background-color: ${containerBackgroundColor};
            overflow: hidden;
          `;
                }
                if (!!backgroundColor) {
                    currentContentProps[mediaQuery] = css `
            ${currentContentProps[mediaQuery]};
            background-color: ${backgroundColor};
          `;
                }
                if (!!overflowHidden) {
                    currentProps[mediaQuery] = css `
            ${currentProps[mediaQuery]};
            overflow: hidden;
          `;
                }
                if (!!fullWidth) {
                    currentContentProps[mediaQuery] = css `
            ${currentContentProps[mediaQuery]};

            max-width: none;
            width: 100%;
          `;
                }
                if (!!cap) {
                    if (mediaQuery !== '$default') {
                        currentContentProps[mediaQuery] = css `
              ${currentContentProps[mediaQuery]};

              ${prepareTabletStyling(theme, getCapValue(cap), !!noPadding)}
            `;
                    }
                    else {
                        currentContentProps[mediaQuery] = css `
              ${currentContentProps[mediaQuery]};
              width: calc(100% - 48px);
              max-width: calc(${cap}px - 300px);
            `;
                    }
                }
                if (!!noPadding) {
                    if (mediaQuery === '$default') {
                        currentProps[mediaQuery] = css `
              ${currentProps[mediaQuery]};
              padding-top: 0;
              padding-bottom: 0;
              margin: 0;
              @media (min-width: ${theme.breakpoints.mobile}px) {
                padding-top: 0;
                padding-bottom: 0;

                margin: 0;
              }
              @media (min-width: ${theme.breakpoints.md}px) {
                padding-bottom: 0;
                padding-bottom: 0;

                margin: 0;
              }
            `;
                        currentContentProps[mediaQuery] = css `
              ${currentContentProps[mediaQuery]};
              padding-top: 0;
              padding-bottom: 0;
              margin: 0 auto;
              @media (min-width: ${theme.breakpoints.mobile}px) {
                padding-top: 0;
                padding-bottom: 0;
                margin: 0 auto;
              }
              @media (min-width: ${theme.breakpoints.md}px) {
                padding-top: 0;
                padding-bottom: 0;
                margin: 0 auto;
              }
            `;
                    }
                    else {
                        currentProps[mediaQuery] = css `
              ${currentProps[mediaQuery]};
              padding-top: 0;
              margin: 0;
            `;
                        currentContentProps[mediaQuery] = css `
              ${currentContentProps[mediaQuery]};
              padding-bottom: 0;
              margin: 0;
            `;
                    }
                }
                if (!!(styles === null || styles === void 0 ? void 0 : styles.container)) {
                    currentProps[mediaQuery] = css `
            ${currentProps[mediaQuery]};
            ${styleToCss(styles.container)}
          `;
                }
                if (!!(styles === null || styles === void 0 ? void 0 : styles.content)) {
                    currentContentProps[mediaQuery] = css `
            ${currentContentProps[mediaQuery]};
            ${styleToCss(styles.content)}
          `;
                }
            }
        };
        const generalProps = {
            children,
            id,
            className,
            removeContainer,
        };
        prepareProps(defaultViewProps, '$default');
        prepareProps(ultra, '$ultra');
        prepareProps(wide, '$wide');
        prepareProps(xxl, '$xxl');
        prepareProps(xl, '$xl');
        prepareProps(l, '$lg');
        prepareProps(md, '$md');
        prepareProps(tablet, '$tablet');
        prepareProps(mobile, '$mobile');
        return { currentProps, currentContentProps, generalProps };
    }, [props, theme]);
};
export default useContainerProps;
